/** Non-throwing connection completeness guard for drag lifecycle.
 * Incomplete connections (missing target) are normal during drag — never throw. */

export type CanvasConnectionValidationResult = 'VALID' | 'INVALID' | 'INCOMPLETE'

export interface CanvasConnectionLike {
  source?: string | null
  target?: string | null
  sourceHandle?: string | null
  targetHandle?: string | null
}

export function validateCanvasConnection(connection: CanvasConnectionLike): CanvasConnectionValidationResult {
  if (!connection.source) return 'INCOMPLETE'
  if (!connection.target) return 'INCOMPLETE'
  if (connection.source === connection.target) return 'INVALID'
  return 'VALID'
}

export function isCompleteCanvasConnection(connection: CanvasConnectionLike): boolean {
  return validateCanvasConnection(connection) === 'VALID'
}
